define.alias("shared/components/shared/pre-boarding/context-modal/bottom-plan-card", "calendar/components/shared/pre-boarding/context-modal/bottom-plan-card");